import { useTcpaQuestionCustomContext } from '../context'

import AnswerTab from './Answer'
import TemplateBuilderTab from './TemplateBuilder'
import { HOOKS } from './TemplateBuilder/Builder/templates'

export function TcpaQuestionCustomProvider() {
  const { tcpaquestioncustom, onChange, disabled } = useTcpaQuestionCustomContext()
  const useTemplateState = HOOKS[tcpaquestioncustom.templateType || 'button-and-dropdown']
  useTemplateState({ tcpaData: tcpaquestioncustom, onChange, disabled })
  return null
}

export function TemplateBuilderContent() {
  const { tcpaquestioncustom, onChange, disabled } = useTcpaQuestionCustomContext()
  return <TemplateBuilderTab data={tcpaquestioncustom} onChange={onChange} disabled={disabled} />
}

export function AnswerContent() {
  const { tcpaquestioncustom, onChange, customField, onAddAnswer, disabled } = useTcpaQuestionCustomContext()
  return <AnswerTab
    onChange={value => onChange('answers', value)}
    answers={tcpaquestioncustom.answers || []}
    customField={customField}
    onAddAnswer={onAddAnswer}
    disabled={disabled}
    skipOption={tcpaquestioncustom.skipOption && !tcpaquestioncustom.isMultipleAnswers}
    skipAnswer={tcpaquestioncustom.skipAnswer}
    onChangeSkipAnswer={(key, value) => onChange('skipAnswer', { ...tcpaquestioncustom.skipAnswer, [key]: value })}
  />
}
